<div class="h-100">
  <div class="row h-100 no-gutters">
    <div class="d-none d-lg-block col-lg-4">
      <div class="slider-light">
        <ngx-slick-carousel class="slick-slider slick-dotted" #slickModal="slick-carousel" [config]="slideConfig2">
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/fx-calculator.png"></div>
                <h3>SAVEDESK Calculator</h3>
                <p>Know what your bank is charging on each CASH ,TOM , SPOT , FORWARD & other FX related transaction. We don’t leave a stone unturned to help you optimise your FX cost.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/alert.png"></div>
                <h3>Rate Alert</h3>
                <p>We don’t let you miss the FX RATE you want, ever! Jus relax, we shall do the tracking.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg opacity-6"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/record-transaction.png"></div>
                <h3>Record your Transactions</h3>
                <p>We let you record all the transactions you cover at a click of a button. Meticulous analytics to help you be on track with your Cost Optimisation journey.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg opacity-6"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/dashboard.png"></div>
                <h3>Dashing Dashboard</h3>
                <p>All your favourite currency pairs and Important FX events and information  at one place. Convenience of-course!</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/analysis.png"></div>
                <h3>Forex Margin Analysis</h3>
                <p>What gets measured gets managed. Know what you are paying & bring in absolute transparency.</p>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
    <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8">
      <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9" style="font-weight: 600;">
        <div class="app-logo"></div>
        <h4 class="mb-0">
          <span>Existing user login here</span>
        </h4>
        <h6 class="mt-3">
          No account?
          <a href="pages/register" class="text-primary">Sign up now</a>
        </h6>
        <div class="divider"></div>
        <div>
          <form [formGroup]="loginForm" #form novalidate="true">
            <div class="row">
              <div class="col-md-6">

                <fieldset class="form-group">
                  <div tabindex="-1" role="group">
                    <label for="exampleEmail">Email</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-envelope"></i></span>
                      </div>
                      <input id="exampleEmail" name="email" type="email" placeholder="Email here..." (keyup.enter)="login()" formControlName="userName"
                      class="form-control" no>
                    </div>

                  </div>
                  <div *ngIf="loginForm.get('userName').touched && loginForm.get('userName').errors?.required"
                            class="form-control-error errors m-1">Please enter the Email Id</div>
                            <div *ngIf="loginForm.get('userName').touched && loginForm.get('userName').errors?.pattern"
                            class="form-control-error errors m-1">Please enter the valid Email Id</div>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset class="form-group">
                  <div tabindex="-1" role="group"><label for="examplePassword">Password</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                          <span class="input-group-text " (click)="passwordShow()" title="{{passShow ? 'Hide' : 'Show'}}"><i class="fa  {{passShow ? 'fa-eye' : 'fa-eye-slash'}} "></i></span>
                      </div>
                      <input 
                      id="examplePassword" name="password" [type]="passShow ? 'text' : 'password'" formControlName="password"
                      placeholder="Password here..." class="form-control" (keyup.enter)="login()">
                    </div>
                    </div>

                </fieldset>
              </div>
            </div>
            <div class="custom-control custom-checkbox"><input id="exampleCheck" type="checkbox" name="check"
                autocomplete="off" class="custom-control-input" value="true"><label for="exampleCheck"
                class="custom-control-label">
                Keep me logged in
              </label></div>
            <div class="divider"></div>
            <div class="d-flex align-items-center">
              <div class="ml-auto"><a href="pages/forgot-password" class="btn-lg btn btn-link">Recover
                  Password</a>
                <button type="button" (click)="login()" [disabled]="!loginForm.valid" class="btn btn-success btn-lg">Login
                  to
                  Dashboard</button>
              </div>
            </div>
          </form>
          <div style="position:fixed; bottom:0; width:50%; height:auto; margin-top:40px;text-align:center">
            <app-footer [needHelp]="true"></app-footer>
            </div>
        </div>
        

      </div>
      
    </div>
  </div>
</div>

